import { render, staticRenderFns } from "./MonitorStatHistory.vue?vue&type=template&id=0f58ed15&scoped=true"
import script from "./MonitorStatHistory.vue?vue&type=script&lang=js"
export * from "./MonitorStatHistory.vue?vue&type=script&lang=js"
import style0 from "./MonitorStatHistory.vue?vue&type=style&index=0&id=0f58ed15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f58ed15",
  null
  
)

export default component.exports